<template>
  <div class="input">
    <label
      :for="inputId"
      class="input-label text-left"
      :aria-label="label"
      :aria-required="required ? 'true' : 'false'"
    >
      {{ label }}<span v-if="required" aria-hidden="true">*</span>
    </label>
    <input
      :id="inputId"
      :type="type"
      :value="value"
      :placeholder="placeholder"
      :aria-required="required ? 'true' : 'false'"
      :aria-invalid="error ? 'true' : 'false'"
      :aria-describedby="error ? errorId : null"
      class="input-field"
      @input="$emit('input', $event.target.value)"
      v-bind="$attrs"
      :tabindex="$attrs.tabindex !== undefined ? $attrs.tabindex : 0"
      autocomplete="off"
    />
    <div v-if="error" :id="errorId" class="input-error" role="alert" aria-live="assertive">
      <font-awesome-icon :icon="['fas', 'circle-exclamation']" /> {{ error }}
    </div>
  </div>
</template>

<script>
export default {
  name: 'Input',
  props: {
    value: [String, Number],
    label: { type: String, required: true },
    type: { type: String, default: 'text' },
    placeholder: { type: String, default: '' },
    error: { type: String, default: '' },
    required: { type: Boolean, default: false },
    id: { type: String, default: null },
  },
  computed: {
    inputId() {
      return this.id || `input-${this._uid}`;
    },
    errorId() {
      return `input-error-${this._uid}`;
    },
  },
};
</script>

<style scoped>
.input {
  display: flex;
  flex-direction: column;
  margin-bottom: 1rem;
}
.input-label {
  font-weight: 600;
  margin-bottom: 0.25rem;
}
.input-field {
  padding: 0.5rem;
  border: 1px solid #ccc;
  border-radius: 4px;
  font-size: 1rem;
  text-align: left;
}
.input-field[aria-invalid="true"] {
  border-color: #e53935;
}
.input-error {
  color: #e53935;
  font-size: 0.875rem;
  margin-top: 0.25rem;
  text-align: left;
}
</style>
